import React from 'react';

const Carts = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.9748 5.53335C15.6165 3.72502 14.2748 2.93335 12.4081 2.93335H5.09147C2.89147 2.93335 1.4248 4.03335 1.4248 6.60002V10.8917C1.4248 12.7417 2.18314 13.825 3.43314 14.2917C3.61647 14.3583 3.81647 14.4167 4.0248 14.45C4.35814 14.525 4.71647 14.5583 5.09147 14.5583H12.4165C14.6165 14.5583 16.0831 13.4583 16.0831 10.8917V6.60002C16.0831 6.20835 16.0498 5.85835 15.9748 5.53335ZM4.60814 10C4.60814 10.3417 4.32481 10.625 3.98314 10.625C3.64147 10.625 3.35814 10.3417 3.35814 10V7.50002C3.35814 7.15835 3.64147 6.87502 3.98314 6.87502C4.32481 6.87502 4.60814 7.15835 4.60814 7.50002V10ZM8.7498 10.95C7.53314 10.95 6.54981 9.96668 6.54981 8.75002C6.54981 7.53335 7.53314 6.55002 8.7498 6.55002C9.96647 6.55002 10.9498 7.53335 10.9498 8.75002C10.9498 9.96668 9.96647 10.95 8.7498 10.95ZM14.1331 10C14.1331 10.3417 13.8498 10.625 13.5081 10.625C13.1665 10.625 12.8831 10.3417 12.8831 10V7.50002C12.8831 7.15835 13.1665 6.87502 13.5081 6.87502C13.8498 6.87502 14.1331 7.15835 14.1331 7.50002V10Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18.5831 9.10001V13.3917C18.5831 15.9583 17.1165 17.0667 14.9081 17.0667H7.59147C6.96647 17.0667 6.40814 16.975 5.92481 16.7917C5.53314 16.65 5.19147 16.4417 4.91647 16.175C4.76647 16.0333 4.88314 15.8083 5.09147 15.8083H12.4081C15.4915 15.8083 17.3248 13.975 17.3248 10.9V6.60001C17.3248 6.40001 17.5498 6.27501 17.6915 6.42501C18.2581 7.02501 18.5831 7.90001 18.5831 9.10001Z",
      fill: "white"
    }
  )
);
Carts.displayName = "Icons.Carts";

export { Carts };
//# sourceMappingURL=Carts.js.map
